import { IResponse, IServiceOpcode, ISearchResult, IOpcodeCount, ISyncStatus, IOnlineCodeSortDetail } from '@signal/asp-data-commons';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {map, switchMap} from 'rxjs/operators';import {environment} from './util.service';
import {selectDealerCode} from '../../store/dealer/dealer.selectors';
import {Store} from '@ngrx/store';
import {DealerState} from '../../store/dealer/dealer.reducer';

@Injectable({
  providedIn: 'root'
})
export class OpCodeService {
  private apiRoot: string;

  constructor(private readonly http: HttpClient,
              private readonly dealerState: Store<DealerState>) {
    this.apiRoot = environment.aspCatalogApi;
  }

  getAllOpCodes(_order: string = 'asc', _sort: string = 'price', _offset: string = '0', _limit: string = '1', _query: string = ''): Observable<ISearchResult<IServiceOpcode[]>> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.get(`${this.apiRoot}service-opcode/${dealerCode}/all-opcodes`).pipe(
      map((data: IResponse<ISearchResult<IServiceOpcode[]>>) => {
        return data.data;
      })
    )
    }));
  }

  getOnlineOpCodes(_order: string = 'asc', _sort: string = 'price', _offset: string = '0', _limit: string = '1', _query: string = ''): Observable<ISearchResult<IServiceOpcode[]>> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.get(`${this.apiRoot}service-opcode/${dealerCode}/online-opcodes`).pipe(
      map((data: IResponse<ISearchResult<IServiceOpcode[]>>) => {
        return data.data;
      })
    )
    }));
  }

  getOpCodesCount(): Observable<IOpcodeCount> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.get(`${this.apiRoot}service-opcode/${dealerCode}/count`).pipe(
      map((data: IResponse<IOpcodeCount>) => {
        return data.data;
      })
    )
    }));
  }

  getOpCodeSortingDetails(): Observable<IOnlineCodeSortDetail> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.get(`${this.apiRoot}service-opcode/${dealerCode}/online/sort`).pipe(
      map((data: IResponse<IOnlineCodeSortDetail>) => {
        return data.data;
      })
    )
    }));
  }

  getOpcodeById(opCodeId: string): Observable<IResponse<IServiceOpcode>> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.get(`${this.apiRoot}service-opcode/${dealerCode}/${encodeURIComponent(opCodeId)}`).pipe(
      map((data: IResponse<IServiceOpcode>) => {
        return data;
      })
    )
    }));
  }

  updateOpCodeSortingDetails(onlineSortingDetails: IOnlineCodeSortDetail): Observable<IOnlineCodeSortDetail> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.patch(`${this.apiRoot}service-opcode/${dealerCode}/online/sort`, onlineSortingDetails).pipe(
      map((data: IResponse<IOnlineCodeSortDetail>) => {
        return data.data;
      })
    )
    }));
  }

  createOpcode(opCode: IServiceOpcode): Observable<IResponse<IServiceOpcode>> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      opCode={...opCode, dealerCode: dealerCode }
    return this.http.post(`${this.apiRoot}service-opcode/${dealerCode}/newOpcode`, opCode).pipe(
         map((data: IResponse<IServiceOpcode>) => {
          return data;
    })
     )
    }));
  }

  updateOpcode(opCodeId: string, opCode: IServiceOpcode): Observable<IResponse<IServiceOpcode>> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.put(`${this.apiRoot}service-opcode/${dealerCode}/${encodeURIComponent(opCodeId)}`, opCode).pipe(
      map((data: IResponse<IServiceOpcode>) => {
        return data;
      })
    )
    }));
  }

  getOpcodeSyncStatus(): Observable<IResponse<ISyncStatus>> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.get(`${this.apiRoot}service-opcode/${dealerCode}/sync-status`, {}).pipe(
      map((data: IResponse<ISyncStatus>) => {
        return data;
      })
    )
    }));
  }

  updateOpcodesFromDms(): Observable<IResponse<IServiceOpcode>> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.post(`${this.apiRoot}service-opcode/${dealerCode}/initiate-sync`, {}).pipe(
      map((data: IResponse<IServiceOpcode>) => {
        return data;
      })
    )
    }));
  }

  updateAspOpcode(aspServiceCode: string, opcode: IServiceOpcode) {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.put(`${this.apiRoot}service-opcode/${dealerCode}/asp-service-opcode/${encodeURIComponent(aspServiceCode)}`, opcode).pipe(
      map((data: IResponse<IServiceOpcode>) => {
        return data;
      })
    )
    }));
  }

  deleteAspServiceCode(aspServiceCode: string) {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.delete(`${this.apiRoot}service-opcode/${dealerCode}/${encodeURIComponent(aspServiceCode)}`).pipe(
      map((data: IResponse<IServiceOpcode>) => {
        return data;
      })
    )
    }));
  }
}
